(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-brand-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('famiware-brand-tabs')) {
    customElements.define('famiware-brand-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.index = 0;
        this.addEventListener('click', event => {
          const tab = event.target.closest('[role="tab"]');
          const arrow = event.target.closest('[data-step]');
          if (tab && this.contains(tab)) this.select(Number(tab.dataset.index));
          if (arrow && this.contains(arrow)) this.select(this.index + Number(arrow.dataset.step));
        }, options);
        this.addEventListener('keydown', event => {
          if (!event.target.closest('[role="tab"]')) return;
          let index;
          if (event.key === 'ArrowRight') index = this.index + 1;
          if (event.key === 'ArrowLeft') index = this.index - 1;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.tabs.length - 1;
          if (index === undefined) return;
          event.preventDefault();
          this.select(index, true);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index !== -1) this.select(index);
        }, options);
      }
      select(index, focus = false) {
        if (!this.tabs.length) return;
        this.index = (index + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === this.index));
          tab.tabIndex = i === this.index ? 0 : -1;
          this.panels[i].hidden = i !== this.index;
        });
        if (focus) this.tabs[this.index].focus();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-pairing-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('star-pairing-offer')) {
    customElements.define('star-pairing-offer', class extends HTMLElement {
      connectedCallback() {
        const rows = [...this.querySelectorAll('[data-item]')];
        const currency = this.dataset.currency || 'USD';
        const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency}).format(cents / 100);
        const option = row => row.querySelector('[data-variant-select]')?.selectedOptions[0];
        const main = rows[0];
        const mainInput = document.querySelector('form[id^="product-form-template"] input[name="id"]');
        const syncMain = () => {
          if (!mainInput) return;
          const select = main.querySelector('[data-variant-select]');
          if ([...select.options].some(item => item.value === String(mainInput.value) && !item.disabled)) select.value = String(mainInput.value);
          this.update();
        };
        if (mainInput) {
          new MutationObserver(syncMain).observe(mainInput,{attributes:true,attributeFilter:['value']});
          document.addEventListener('change', () => setTimeout(syncMain, 0));
        }
        this.addEventListener('change', () => this.update());
        this.addEventListener('input', event => { if (event.target.matches('[data-quantity]')) this.update(); });
        this.querySelector('[data-add]').addEventListener('click', async () => {
          const button = this.querySelector('[data-add]');
          const status = this.querySelector('[data-status]');
          const lines = this.lines();
          if (!lines.length || !this.validSelection()) return;
          button.disabled = true;
          button.setAttribute('aria-busy','true');
          status.textContent = 'Adding selected items…';
          try {
            const route = (window.Shopify?.routes?.root || '/').replace(/\/$/, '') + '/cart/add.js';
            const response = await fetch(route,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:lines.map(line => ({id:Number(line.id),quantity:line.quantity}))})});
            if (!response.ok) { const error = await response.json(); throw new Error(error.description || error.message || 'Cart update failed.'); }
            status.textContent = 'Items added. Review your checkout price before paying.';
            window.location.assign((window.Shopify?.routes?.root || '/').replace(/\/$/, '') + '/cart');
          } catch (error) {
            status.textContent = error.message || 'Could not add these items. Please try again.';
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        });
        this.money = money;
        this.rows = rows;
        this.update();
      }
      lines() {
        return this.rows.flatMap((row,index) => {
          if (index > 0 && !row.querySelector('[data-include]')?.checked) return [];
          const selected = row.querySelector('[data-variant-select]')?.selectedOptions[0];
          if (!selected || selected.disabled) return [];
          const quantity = index === 0 ? Math.max(1, Math.min(10, Number(row.querySelector('[data-quantity]').value) || 1)) : 1;
          return [{id:selected.value,quantity,price:Number(selected.dataset.price)||0}];
        });
      }
      validSelection() {
        return this.rows.every((row,index) => index === 0 || !row.querySelector('[data-include]')?.checked || !row.querySelector('[data-variant-select]')?.selectedOptions[0]?.disabled);
      }
      update() {
        if (!this.rows) return;
        for (const row of this.rows) {
          const selected = row.querySelector('[data-variant-select]')?.selectedOptions[0];
          if (!selected) continue;
          row.querySelector('[data-sku]').textContent = selected.dataset.sku || '';
          row.querySelector('[data-line-price]').textContent = this.money(Number(selected.dataset.price)||0);
          const image = row.querySelector('.star-pairing__image');
          if (image && selected.dataset.image) image.src = selected.dataset.image;
        }
        const qtyInput = this.querySelector('[data-quantity]');
        qtyInput.value = String(Math.max(1,Math.min(10,Number(qtyInput.value)||1)));
        const lines = this.lines();
        const count = lines.reduce((sum,line)=>sum+line.quantity,0);
        const subtotal = lines.reduce((sum,line)=>sum+line.price*line.quantity,0);
        const rate = count >= 3 ? .20 : count >= 2 ? .15 : 0;
        const savings = Math.round(subtotal*rate);
        this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
        this.querySelector('[data-savings]').textContent = '−' + this.money(savings);
        this.querySelector('[data-total]').textContent = this.money(subtotal-savings);
        this.querySelector('.star-pairing__progress').setAttribute('aria-valuenow',String(Math.min(count,3)));
        this.querySelector('.star-pairing__progress span').style.width = Math.min(count/3*100,100)+'%';
        this.querySelectorAll('[data-tier]').forEach(tier => tier.classList.toggle('is-current',Number(tier.dataset.tier)===(count>=3?3:count===2?2:0)));
        this.querySelector('.star-pairing__progress-copy').textContent = count>=3 ? '3+ sets selected · 20% preview tier' : count===2 ? '2 sets selected · 15% preview tier' : 'Add 1 more set to reach the 15% preview tier';
        this.querySelector('[data-add]').disabled = !this.validSelection();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-real-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('star-real-videos')) {
    customElements.define('star-real-videos', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController(); const options = {signal:this.abort.signal};
        this.track = this.querySelector('.srv__track'); this.cards = [...this.querySelectorAll('[data-card]')];
        this.dialog = this.querySelector('dialog'); this.player = this.querySelector('.srv__player');
        this.soundButton = this.dialog.querySelector('[data-sound]');
        this.retryButton = this.dialog.querySelector('[data-retry]');
        this.playbackStatus = this.dialog.querySelector('.srv__playback-status');
        this.addEventListener('click', event => {
          const play = event.target.closest('[data-play]');
          const direction = event.target.closest('[data-direction]');
          const jump = event.target.closest('[data-jump]');
          if(play && !play.disabled) this.openClip(play.dataset.play,play);
          if(direction) this.scrollToCard(this.nearest()+Number(direction.dataset.direction));
          if(jump) this.scrollToCard(this.cards.findIndex(card=>card.dataset.card===jump.dataset.jump));
          if(event.target.closest('[data-sound]')) this.toggleSound();
          if(event.target.closest('[data-retry]')) this.playCurrent();
          if(event.target.closest('[data-close]')) this.dialog.close();
        },options);
        this.track.addEventListener('keydown',event=>{
          if(event.target!==this.track)return;
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
          event.preventDefault();
          this.scrollToCard(event.key==='Home'?0:event.key==='End'?this.cards.length-1:this.nearest()+(event.key==='ArrowRight'?1:-1));
        },options);
        this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());},options);
        this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();},options);
        this.dialog.addEventListener('close',()=>{this.stop();this.opener?.focus({preventScroll:true});},options);
        document.addEventListener('visibilitychange',()=>{if(document.hidden)this.player.querySelector('video')?.pause();},options);
        window.addEventListener('pagehide',()=>this.stop(),options);
        document.addEventListener('play',event=>{const current=this.player.querySelector('video');if(this.dialog.open&&current&&event.target.tagName==='VIDEO'&&event.target!==current)event.target.pause();},{...options,capture:true});
        document.addEventListener('shopify:block:select',event=>{const index=this.cards.findIndex(card=>card.dataset.card===event.detail.blockId);if(index>=0)this.scrollToCard(index);},options);
        this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
      }
      nearest(){const left=this.track.getBoundingClientRect().left;let index=0,min=Infinity;this.cards.forEach((card,i)=>{const distance=Math.abs(card.getBoundingClientRect().left-left);if(distance<min){min=distance;index=i;}});return index;}
      scrollToCard(index){const card=this.cards[Math.max(0,Math.min(index,this.cards.length-1))];if(!card)return;this.track.scrollBy({left:card.getBoundingClientRect().left-this.track.getBoundingClientRect().left-4,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
      update(){const index=this.nearest();this.querySelectorAll('[data-jump]').forEach(button=>button.setAttribute('aria-current',String(button.dataset.jump===this.cards[index]?.dataset.card)));const max=this.track.scrollWidth-this.track.clientWidth;this.querySelector('[data-direction="-1"]').disabled=this.track.scrollLeft<4;this.querySelector('[data-direction="1"]').disabled=this.track.scrollLeft>=max-4;}
      openClip(id,opener){
        const template=[...this.querySelectorAll('template[data-clip]')].find(item=>item.dataset.clip===id);if(!template?.content.querySelector('video'))return;
        document.querySelectorAll('video').forEach(video=>video.pause());this.stop();this.opener=opener;
        this.dialog.querySelector('h3').textContent=template.dataset.title;
        this.dialog.querySelector('.srv__dialog-description').textContent=template.dataset.description;
        const error=this.dialog.querySelector('.srv__error');error.hidden=true;
        const content=template.content.cloneNode(true),video=content.querySelector('video');
        video.muted=matchMedia('(max-width: 749px)').matches;
        video.defaultMuted=video.muted;
        video.setAttribute('aria-label',template.dataset.title);
        video.addEventListener('volumechange',()=>this.updateSoundButton());
        video.addEventListener('playing',()=>{if(this.player.querySelector('video')!==video)return;clearTimeout(this.playTimer);this.playbackStatus.hidden=true;this.retryButton.hidden=true;});
        video.addEventListener('error',()=>{if(this.player.querySelector('video')!==video)return;clearTimeout(this.playTimer);error.textContent=this.dataset.error;error.hidden=false;this.playbackStatus.hidden=true;this.retryButton.hidden=true;},{once:true});
        this.player.append(content);
        this.retryButton.hidden=true;
        this.playbackStatus.hidden=true;
        this.updateSoundButton();
        if(!this.dialog.open)this.dialog.showModal();
        this.playCurrent();
        this.dialog.querySelector('[data-close]').focus();
      }
      playCurrent(){
        const video=this.player.querySelector('video');if(!video)return;
        this.retryButton.hidden=true;this.playbackStatus.hidden=false;
        clearTimeout(this.playTimer);
        this.playTimer=setTimeout(()=>{if(this.player.querySelector('video')===video&&video.paused){this.playbackStatus.hidden=true;this.retryButton.hidden=false;}},5000);
        try { Promise.resolve(video.play()).catch(()=>{if(this.player.querySelector('video')!==video)return;clearTimeout(this.playTimer);this.playbackStatus.hidden=true;this.retryButton.hidden=false;}); }
        catch { clearTimeout(this.playTimer);this.playbackStatus.hidden=true;this.retryButton.hidden=false; }
      }
      toggleSound(){const video=this.player.querySelector('video');if(!video)return;video.muted=!video.muted;this.updateSoundButton();if(video.paused)this.playCurrent();}
      updateSoundButton(){const video=this.player.querySelector('video');if(!video)return;const soundOn=!video.muted;this.soundButton.textContent=soundOn?this.soundButton.dataset.soundOff:this.soundButton.dataset.soundOn;this.soundButton.setAttribute('aria-pressed',String(soundOn));}
      stop(){clearTimeout(this.playTimer);const video=this.player?.querySelector('video');if(video){video.pause();video.removeAttribute('src');video.querySelectorAll('source').forEach(source=>source.removeAttribute('src'));video.load();}this.player?.replaceChildren();if(this.retryButton)this.retryButton.hidden=true;if(this.playbackStatus)this.playbackStatus.hidden=true;}
      disconnectedCallback(){this.stop();if(this.dialog?.open)this.dialog.close();this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-scene-switcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('famiware-scene-switcher')) {
    customElements.define('famiware-scene-switcher', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.scenes = Array.from(this.querySelectorAll('[data-scene]'));
        this.choices = Array.from(this.querySelectorAll('[data-choice]'));
        this.current = 0;
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-choice]');
          const step = event.target.closest('[data-step]');
          if (choice) this.show(Number(choice.dataset.choice));
          if (step) this.show(this.current + Number(step.dataset.step));
        }, options);
        this.addEventListener('keydown', event => {
          if (!event.target.closest('[data-choice]')) return;
          const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let next = this.current + (['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.scenes.length - 1;
          this.show(next);
          this.choices[this.current].focus();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const scene = event.target.closest('[data-scene]');
          if (scene) this.show(Number(scene.dataset.scene));
        }, options);
      }
      disconnectedCallback() { if (this.controller) this.controller.abort(); }
      show(index) {
        if (!this.scenes.length) return;
        this.current = (index + this.scenes.length) % this.scenes.length;
        this.scenes.forEach((scene, i) => {
          scene.classList.toggle('is-active', i === this.current);
          scene.setAttribute('aria-hidden', String(i !== this.current));
        });
        this.choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === this.current)));
        this.querySelector('.fss__status').textContent = this.choices[this.current].textContent.trim() + '. ' + this.scenes[this.current].querySelector('.fss__copy').textContent.trim();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
